// extracted by css-extract-rspack-plugin
export default {"clientTeamLabel":"clientTeamLabel-WLRKdO text-sm-medium","reasonLabel":"reasonLabel-OR5XTV text-sm-medium","reasonHelp":"reasonHelp-MlULZR text-sm-light"};